import React from 'react'
import ApiServiceSingleton from '../../services/api/ApiServiceSingleton'
import './BankStatements.scss'

import Environment from '../../services/environment/Environment'
import Loading from '../../components/Loading/Loading'
import { removeHeaderPhone } from '../../components/TPHeader/TPHeader'
import ErrorDisplay from '../../components/ErrorDisplay/ErrorDisplay'
import LabelValue from '../../components/LabelValue/LabelValue'
import LabelValueRaw from '../../components/LabelValueRaw/LabelValueRaw'
import { asCurrency, asPhoneNumber } from '../../utils/format'
import resolveProperty from "../../utils/resolveProperty"

const BankStatementsStatus = Object.freeze({unresolved: 1, error: 2, found: 3})

class BankStatements extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      status: BankStatementsStatus.unresolved
    }
  }

  componentDidMount() {
    let repository = ApiServiceSingleton.repository('loanEnquiryDetails')
    repository.getById(this.props.loanEnquiryDetailId).then((loanEnquiryDetail) => {
      if (loanEnquiryDetail.type === 'electronic-bank-statements' && loanEnquiryDetail.response) {
        this.setState({status: BankStatementsStatus.found, loanEnquiryDetail: loanEnquiryDetail})
      } else {
        this.setState({status: BankStatementsStatus.error, error: {message: 'We were unable to find your information.'}})
      }
    }).catch((e) => {
      this.setState({status: BankStatementsStatus.error, error: {message: 'We were unable to find your information.', baseError: e}})
    })
  }

  render() {
    switch (this.state.status) {
      case BankStatementsStatus.found:
        return this._bankStatements(this.state.loanEnquiryDetail)
      case BankStatementsStatus.unresolved:
        return <Loading/>
      case BankStatementsStatus.error:
      default:
        return <ErrorDisplay detail={this.state.error}/>
    }
  }

  _createAssistance(loanEnquirySummary, referrerDetails) {
    const assetRideShareElectricVehicle = resolveProperty(loanEnquirySummary, 'assetRideShareElectricVehicle')
    if (assetRideShareElectricVehicle === 'yes') {
      const phone = referrerDetails.phone
      const phoneLink = (<a href={`tel:${phone}`}>{asPhoneNumber(phone)}</a>)
      const email = referrerDetails.email
      const emailLink = (<a href={`mailto:${email}`}>{email}</a>)
      const referrerName = referrerDetails.name
      const referrerCompany = ((referrerCompany) => {
        return (referrerCompany !== undefined && referrerCompany.toString().trim() !== '') ? ` from ${referrerCompany.toString()}` : ''
      })(referrerDetails.company)
      removeHeaderPhone()

      return (
        <div className="referrer-assistance">
          <h2>🛎️ Need help with your loan enquiry?</h2>
          <p>Please contact your broker: <span className="referrer-name">{referrerName}</span>{referrerCompany}</p>
          <LabelValueRaw label="Phone" value={phoneLink}/>
          <LabelValueRaw label="Email" value={emailLink}/>
        </div>
      )
    }
  }

  _bankStatements(loanEnquiryDetail) {
    const loanEnquirySummary = loanEnquiryDetail.request.loanEnquirySummary
    const referrerDetails = loanEnquiryDetail.request.referrerDetails
    const loanEnquiryDetailResponse = this._loanEnquiryDetailResponseMapping(loanEnquiryDetail)
    const assistance = this._createAssistance(loanEnquirySummary, referrerDetails)
    const header = (
      <header className="article-header">
        <p className="borrower-entity-name">{loanEnquirySummary.name}</p>
      </header>
    )
    const instructionMessage = `TruePillars has invited you to complete Bank Statements as part of your loan enquiry.`

    return (
      <article className="bank-statements">
        {header}
        <main>
          <div className="wrapper">
            <section className="instructions">
              <p className="salutation">Hi {loanEnquiryDetailResponse.electronicBankStatements.clientFirstName},</p>
              <p>{instructionMessage}</p>
              <p>This secure process gives us a 360 degree view of your transaction history, and is required in order to progress your loan enquiry.</p>
              <a className="external-link" target="_blank" rel="noopener noreferrer" href="https://bankstatements.com.au/about">Learn more about Bank Statement</a>
            </section>
            <section className="loan-enquiry-details">
              <h2>Your loan enquiry details</h2>
              <div className="details">
                <LabelValue label="Name" value={loanEnquiryDetailResponse.electronicBankStatements.clientFirstName + ' ' + loanEnquiryDetailResponse.electronicBankStatements.clientLastName}/>
                <LabelValue label="Amount" value={asCurrency(loanEnquirySummary.amount, 0)}/>
                <LabelValue label="Email" value={loanEnquiryDetailResponse.electronicBankStatements.clientEmail}/>
                <LabelValue label="Purpose" value={loanEnquirySummary.purpose}/>
              </div>
              {assistance}
            </section>
          </div>
          <section className="bank-statement">
            <h2>Bank statement</h2>
            <iframe id="bank-statement-iframe" src={Environment.BANK_STATEMENTS_IFRAME_URL + '-' + loanEnquiryDetail.id.substring(0, 8)} title="Bank statement">
              iframes are not supported in this browser
            </iframe>
          </section>
        </main>
      </article>
    )
  }

  _loanEnquiryDetailResponseMapping(loanEnquiryDetail) {
    return loanEnquiryDetail.response.enquiryDetails.reduce((result, qad) => {
      if (qad.name.includes('.')) {
        const keys = qad.name.split('.')
        if (!result[keys[0]]) {
          result[keys[0]] = {}
        }
        result[keys[0]][keys[1]] = qad.answer
      } else {
        result[qad.name] = qad.answer
      }
      return result
    }, {})
  }
}

export default BankStatements
